import { render } from "./change-username.vue?vue&type=template&id=7fb66520"
import script from "./change-username.vue?vue&type=script&lang=js"
export * from "./change-username.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__